/* eslint-disable import/prefer-default-export */
import { usePOSCoreApiClient } from './services/core';
import { useShorePayApi } from './services/shorepay';
import { useCustomerDisplayApi } from './services/customerdisplay';
import { useAppsManagementApi } from './services/appsmanagement';
import { useContactsApi, useCustomersApi } from './services/contacts';
import { useReportsApi } from './services/reports';
import { useCommonApi } from './services/common';
import { useSettingsApi } from './services/settings';
import { useInventoryApi } from './services/inventory';
import { useStocktakingApi } from './services/stocktaking';
import { useDatevApi } from './services/datev';
import { useKsvApi } from './services/ksv';
import { useRKSVapi } from './services/rksv';
import { useSubscriptionApi } from './services/subscription';

export const useApiClient = () => {
  const ShorePay = useShorePayApi();
  const CoreApi = usePOSCoreApiClient();
  const CustomerDisplay = useCustomerDisplayApi();
  const AppsManagement = useAppsManagementApi();
  const Contacts = useContactsApi();
  const Reports = useReportsApi();
  const Common = useCommonApi();
  const Settings = useSettingsApi();
  const Inventory = useInventoryApi();
  const Customers = useCustomersApi();
  const StockTaking = useStocktakingApi();
  const Datev = useDatevApi();
  const Ksv = useKsvApi();
  const Rksv = useRKSVapi();
  const Subscription = useSubscriptionApi();

  return {
    ShorePay,
    CoreApi,
    CustomerDisplay,
    AppsManagement,
    Contacts,
    Reports,
    Settings,
    Common,
    Inventory,
    Customers,
    StockTaking,
    Datev,
    Ksv,
    Rksv,
    Subscription,
  };
};
